import { parentChains } from 'main/hotelBrandsAndChains'

export function getLoyaltyLevelText(parentChainCode, loyaltyLevel) {
  function capitalizeFirstLetter(string) {
    return string
      ? string?.charAt(0)?.toUpperCase() + string?.toLowerCase()?.slice(1)
      : ''
  }

  const IHGlevelToText = {
    CLUB: 'Club',
    GOLD: 'Gold Elite',
    PLATINUM: 'Platinum Elite',
    SPIRE: 'Spire Elite'
  }

  const HyattLevelToText = {
    MEMB: 'World of Hyatt Member',
    DISV: 'Discoverist',
    EXPL: 'Explorist',
    GLOB: 'Globalist',
    LGLO: 'Life Time Globalist'
  }

  switch (parentChainCode) {
    case parentChains.choice:
      return loyaltyLevel

    case parentChains.ihg:
      return IHGlevelToText?.[loyaltyLevel]

    case parentChains.wyndham:
      return capitalizeFirstLetter(loyaltyLevel)

    case parentChains.hyatt:
      return HyattLevelToText?.[loyaltyLevel]

    case parentChains.radisson:
      return capitalizeFirstLetter(loyaltyLevel)

    case parentChains.marriott:
      return capitalizeFirstLetter(loyaltyLevel)

    case parentChains.bestwestern:
      return capitalizeFirstLetter(loyaltyLevel)

    default:
      return null
  }
}
